import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, catchError, switchMap, withLatestFrom, filter } from 'rxjs/operators';
import * as LoadOptionsActions from '../actions/load-options.actions';
import { SpotsService } from '../services/spots.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';

@Injectable()
export class LoadOptionsEffects {

  loadLoadOptions$ = createEffect(() =>
    this.actions$.pipe(
      ofType(LoadOptionsActions.loadLoadOptions),
      withLatestFrom(this.store.select(state => state.spots.loadOptions)),
      filter(([action, loadOptions]) => !loadOptions), // only continue if it was not loaded before
      switchMap(([action, loadOptions]) => {
        const { organizationId } = action;
        return this.spotsService.getLoadOptions(organizationId).pipe(
          map(loadOptions => LoadOptionsActions.loadLoadOptionsSuccess({ loadOptions })),
          catchError(error => of(LoadOptionsActions.loadLoadOptionsFailure({ error })))
        )
      })
    )
  );

  constructor(
    private actions$: Actions,
    private spotsService: SpotsService,
    private store: Store<AppState>
  ) {}
}
